import {withState, t} from 'shared/core';
import {policyLink, termsLink} from 'shared/tools';
import {observer} from 'mobx-react';
import {FormattedMessage} from 'react-intl';
import {Input, Button, FormLayout, DatePicker, QuickTip, BrandedContainer} from 'shared/components';
import {EmployeeSignupState} from '../state';
import _ from 'lodash';
import {LoginOAuth}  from 'shared/components/login';

const marketingCopy = (invite) => ({
  info: <FormattedMessage id='user_signup.signup.employee.collage.marketing_copy_1'/>,
  header: <FormattedMessage id='user_signup.signup.employee.collage.MARKETING_HEADER' values={{companyName: invite.companyName}}/>
});

const ErrorMessage = observer(({uiState}) => {
  const {validateSignupFormErrors} = uiState;
  if (_.isEmpty(validateSignupFormErrors)) return null;

  return (
    <QuickTip trait='error'>
      <FormattedMessage id='user_signup.signup.employee.details_do_not_match'/>
    </QuickTip>
  );
});

const InfoMessage = observer(({uiState}) => {
  const {validateSignupFormErrors} = uiState;
  if (!_.isEmpty(validateSignupFormErrors)) return null;

  return (
    <QuickTip
      trait='caution'
      header={t('user_signup.signup.employee.enter_your_details_header')}
    >
      <FormattedMessage id='user_signup.signup.employee.enter_your_details'/>
    </QuickTip>
  );
});

const ValidateSignupForm = observer(({uiState}) => {
  const {validateSignupForm, validateSignupFormErrors, birthDateRequired} = uiState;

  return (
    <form>
      <FormLayout>
        <InfoMessage uiState={uiState}/>
        <ErrorMessage uiState={uiState}/>
        <Input
          value={validateSignupForm.lastName}
          label='user_signup.signup.employee.Last Name'
          onChange={e => validateSignupForm.merge({lastName: e.target.value})}
          errorMessage={validateSignupFormErrors.lastName}
        />
        {birthDateRequired &&
          <DatePicker
            label='user_signup.signup.employee.Date of Birth'
            value={validateSignupForm.birthDate}
            onChange={birthDate => validateSignupForm.merge({birthDate})}
            options={{startView: 2}}
            errorMessage={validateSignupFormErrors.birthDate}
          />
        }
        <Button className='full-width' onClick={() => uiState.validateInvite()}>
          <FormattedMessage id='user_signup.signup.employee.Continue'/>
        </Button>
      </FormLayout>
    </form>
  );
});

const SignupForm = observer(({uiState}) => {
  const {form, errors} = uiState;

  return (
    <div>
      <div className='h2 medium center mb3'>
        <FormattedMessage id='user_signup.signup.employee.Create Your Account'/>
      </div>
      <LoginOAuth
        context='user_invitation_signup'
        token={uiState.form.token}
      />
      <form>
        <FormLayout>
          <Input
            value={form.email}
            placeholder='user_signup.signup.employee.Email'
            onChange={e => form.merge({email: e.target.value})}
            errorMessage={errors.email}
          />
          <Input
            value={form.emailConfirmation}
            placeholder='user_signup.signup.employee.Confirm Email'
            onChange={e => form.merge({emailConfirmation: e.target.value})}
            errorMessage={errors.emailConfirmation}
          />
          <Input type='password' className='full-width'
            value={form.password}
            placeholder='user_signup.signup.employee.Password'
            onChange={e => form.merge({password: e.target.value})}
            errorMessage={errors.password}
          />
        </FormLayout>
        <Button className='full-width' onClick={() => uiState.signUp()}>
          <FormattedMessage id='user_signup.signup.employee.Sign Up'/>
        </Button>
        <div className='mt2 h5 waterloo center'>
          <FormattedMessage id='signup.SERVICE_AGREEMENT_AND_PRIVACY_POLICY' values={{
            terms: <a href={termsLink()} target='_blank' className='TextLink dodger' rel='noreferrer'><FormattedMessage id='signup.Terms'/></a>,
            privacyPolicy: <a href={policyLink()} target='_blank' className='TextLink dodger' rel='noreferrer'><FormattedMessage id='signup.Privacy Policy'/></a>
          }}/>
        </div>
      </form>
    </div>
  );
});

const EmployeeSignupForm = observer(({uiState}) => {
  const {invite, invitationValidated} = uiState;

  return (
    <BrandedContainer
      {...marketingCopy(invite)}
    >
      <div className='center mb3'>
        <div className='big-logo mx-auto'></div>
      </div>
      {invitationValidated && <SignupForm uiState={uiState}/>}
      {!invitationValidated && <ValidateSignupForm uiState={uiState}/>}
    </BrandedContainer>
  );
});

export default withState(EmployeeSignupForm, EmployeeSignupState);
